/**
 * systemNoticeModule 系统公告
 * Qian.qianchen
 * 2019-06-27
 */
angular.module("systemNoticeModule", ["editNoticeModule", "systemNoticeRouterModule", "systemNoticeServiceModule", "noticeDetailModule","timeShowFormatModule"]).
controller("systemNoticeCtrl", ["$scope", "$state", "$q", "trsHttpService", "modalDialog", "trsspliceString",
    function($scope, $state, $q, trsHttpService, modalDialog, trsspliceString) {
        initStatus()
        initData()
        /**
         * [initStatus description:初始化状态]
         */
        function initStatus() {
            $scope.data = {
                items: [], //公告列表
                selectedArray: [], //已选
                keyWords: '', //关键字
                typeid: '', //类型id
                status: '', //状态
                typeArray: [
                    { name: '全部类型', value: -1 }
                ],
                statusArray: [
                    { name: '全部状态', value: -1 },
                    { name: '待发布', value: 0 },
                    { name: '已发布', value: 1 }
                ],
                inputFocusFlag: false,
            };
            /**
             * [page description:分页信息]
             */
            $scope.hotLists = {
                page: {
                    "pn": 0, //当前页
                    "PAGESIZE": 20, //globleParamsSet.getPageSize(),
                    "ITEMCOUNT": 0, //总共多少数据
                    "startpage": 0,
                },
                status: {
                    "jumpToPageNum": 1,
                    "startpage": 0
                }
            };
        }
        /**
         *  
         * [getData description:数据请求函数]
         */
        function getData(page) {
            let defer = $q.defer();
            let params = {
                serviceid: "notice",
                method: "noticeList",
                pageNumber: $scope.hotLists.page.startpage,
                pageSize: $scope.hotLists.page.PAGESIZE,
            }
            if ($scope.data.keyWords) {
                params.keyWords = $scope.data.keyWords;
            }
            if ($scope.data.typeid.value != -1) {
                params.typeid = $scope.data.typeid.value;
            }
            if ($scope.data.status.value != -1) {
                params.status = $scope.data.status.value;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(data) {
                $scope.data.items = data.data.content;
                $scope.hotLists.page.ITEMCOUNT = data.data.totalElements;
                $scope.hotLists.page.pn = data.data.number + 1;
                $scope.hotLists.page.PAGECOUNT = data.data.totalPages;
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [getNoticeType description:获取公告类型列表]
         */
        function getNoticeType() {
            $scope.data.typeid = $scope.data.typeArray[0];
            let defer = $q.defer();
            let params = {
                serviceid: 'noticetype',
                method: 'noticetypeForDetail'
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(data) {
                if (data.issuccess == "false") {
                    modalDialog.alertType('', data.msg, 'error', false);
                    defer.reject()
                } else {
                    $scope.data.typeArray = [
                        { name: '全部类型', value: -1 }
                    ];
                    $scope.data.typeArray = $scope.data.typeArray.concat(data.data.map(_item => {
                        return { name: _item.typename, value: _item.typeid };
                    }));
                    defer.resolve();
                }
            });
            return defer.promise;
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            $scope.data.status = $scope.data.statusArray[0];
            getNoticeType();
            getData()
        }
        /**
         * [requestData description]改变条件，请求数据
         * @param  {[type]} ev [description]
         */
        $scope.requestData = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                getData()
                console.log($scope.data.keyWords)
            }
        }
        /**
         * [pageChanged description]分页请求
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.hotLists.status.jumpToPageNum = $scope.data.hotLists.page.pn;
            $scope.hotLists.page.startpage = $scope.data.hotLists.page.pn - 1;
            getData();
            $scope.data.selectedArray = [];
        };
        /**
         * [jumpToPage description] 跳转分页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.data.hotLists.status.jumpToPageNum > $scope.data.hotLists.page.PAGECOUNT) {
                $scope.data.hotLists.status.jumpToPageNum = $scope.data.hotLists.page.PAGECOUNT;
            }
            if ($scope.data.hotLists.status.jumpToPageNum === "0" || isNaN(Number($scope.data.hotLists.status.jumpToPageNum))) {
                modalDialog.alertType("请输入合法的页码", "", "warning", false);
                return;
            }
            $scope.data.hotLists.page.startpage = $scope.data.hotLists.status.jumpToPageNum - 1;
            getData();
            $scope.data.selectedArray = [];
        };
        /**
         * [checkSelect description] 判断是否选中
         * @return {[boolean]}[description]
         */
        $scope.checkSelect = function(item) {
            return $scope.data.selectedArray.some((_item) => {
                return _item.noticeid == item.noticeid;
            })
        }
        /**
         * [selectCheckAdd description] 选中/取消选中元素
         * @param  {[type]} item [description] 元素
         * @return {[type]}      [description]
         */
        $scope.selectCheckAdd = function(item) {
            if ($scope.checkSelect(item)) {
                $scope.data.selectedArray = $scope.data.selectedArray.filter((_item) => {
                    return _item.noticeid != item.noticeid;
                })
            } else {
                $scope.data.selectedArray.push(item)
            }
        }
        /**
         * [selectAll description] 全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.selectedArray.length == $scope.data.items.length && $scope.data.items.length > 0) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [].concat($scope.data.items);
            }
        }

        /**
         * [release description] 发布
         */
        $scope.release = function(item) {
            let defer = $q.defer();
            modalDialog.confirmModal('', angular.isDefined(item) ? '确定发布该公告？' : '确认发布选中的公告', function() {
                let params = {
                    serviceid: "notice",
                    method: "publishNotice",
                    noticeids: angular.isDefined(item) ? item.noticeid : trsspliceString.spliceString($scope.data.selectedArray, "noticeid", ","),
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "POST").then(function(data) {
                    if (data.issuccess == 'true') {
                        modalDialog.alertType('', '发布成功', 'success', false);
                        $scope.data.selectedArray = [];
                    } else if (data.msg == null) {
                        let report = data.data.map((_item) => {
                            return { TITLE: _item.issuccess == "true" ? '发布成功' : '发布失败', DETAIL: _item.msg, ISSUCCESS: _item.issuccess };
                        });
                        modalDialog.multiReportsAlert({ TITLE: '发布结果', ISSUCCESS: false, REPORTS: report });
                    } else {
                        modalDialog.alertType('', data.msg, 'error', false);
                    }
                    defer.resolve();
                    getData();
                });
            });
            return defer.promise;
        }
        /**
         * [createOrEdit description] 新建/编辑公告
         * @param  {[type]} item [description] 公告
         * @return {[type]}      [description]
         */
        $scope.createOrEdit = function(item) {
            $state.go('manageconfig.sysmanage.systemnotice.editnotice', angular.isDefined(item) ? { noticeid: item.noticeid } : {});
        }
    }
]);